var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { attrs: { id: "app" }, on: { click: _vm.outsideClick } },
    [
      _c(
        "div",
        {
          class: [
            _vm.showMessageBar ? "active" : "",
            "c-page-head__message",
            _vm.messageType,
          ],
        },
        [
          _vm._l(_vm.messages, function (message) {
            return _c("p", {
              attrs: { "data-cy": "flash-message" },
              domProps: { innerHTML: _vm._s(message) },
            })
          }),
          _vm._v(" "),
          _c(
            "button",
            { staticClass: "button-close", on: { click: _vm.closeMessage } },
            [
              _c("img", {
                attrs: {
                  src: "/img/ui/icon-close.svg",
                  alt: "Close",
                  width: "14",
                  height: "14",
                },
              }),
            ]
          ),
        ],
        2
      ),
      _vm._v(" "),
      _c(
        "header",
        { ref: "pageHead", staticClass: "c-page-head content" },
        [
          typeof _vm.$root.community == "undefined" ||
          (typeof _vm.$root.community != "undefined" &&
            typeof _vm.$root.community.id == "undefined")
            ? [
                _c(
                  "a",
                  { staticClass: "c-page-head__logo", attrs: { href: "/" } },
                  [
                    _c("img", {
                      attrs: {
                        src: "/img/logo-dyadey-main.svg",
                        alt: "Dyadey",
                        width: _vm.logoWidth,
                        height: "33",
                      },
                    }),
                  ]
                ),
              ]
            : typeof _vm.$root.post != "undefined"
            ? [
                _vm._m(0),
                _vm._v(" "),
                _c(
                  "a",
                  {
                    staticClass: "c-page-head__logo c-page-head__logo--ugc",
                    attrs: { href: "/" + _vm.$root.post.community_url },
                  },
                  [
                    _c("img", {
                      attrs: {
                        src: _vm.$simpleStore.cloudinaryUrl(
                          23,
                          23,
                          "img/communities/" +
                            _vm.$root.post.community_id +
                            "/" +
                            _vm.$root.post.community_thumbnail,
                          _vm.$root
                        ),
                        alt: _vm.$root.post.community_name,
                        width: "23",
                        height: "23",
                      },
                    }),
                    _vm._v(" "),
                    _c("p", [_vm._v(_vm._s(_vm.$root.post.community_name))]),
                  ]
                ),
              ]
            : typeof _vm.$root.community != "undefined" &&
              typeof _vm.$root.community.id != "undefined"
            ? [
                _vm._m(1),
                _vm._v(" "),
                _c(
                  "a",
                  {
                    staticClass: "c-page-head__logo c-page-head__logo--ugc",
                    attrs: { href: "/" + _vm.$root.community.url },
                  },
                  [
                    _c("img", {
                      attrs: {
                        src: _vm.$simpleStore.cloudinaryUrl(
                          23,
                          23,
                          "img/communities/" +
                            _vm.$root.community.id +
                            "/" +
                            _vm.$root.community.image,
                          _vm.$root
                        ),
                        alt: _vm.$root.community.name,
                        width: "23",
                        height: "23",
                      },
                    }),
                    _vm._v(" "),
                    _c("p", [_vm._v(_vm._s(_vm.$root.community.name))]),
                  ]
                ),
              ]
            : _vm._e(),
          _vm._v(" "),
          _c(
            "a",
            {
              staticClass: "u-hidden@l",
              attrs: {
                href: "/communities",
                "data-tour-desktop": "communities",
              },
            },
            [_vm._v("Communities")]
          ),
          _vm._v(" "),
          _vm.showBackLink
            ? _c(
                "div",
                {
                  staticClass: "c-page-head__back",
                  attrs: { onclick: "window.history.back()" },
                },
                [
                  _c("img", {
                    attrs: {
                      src: "/img/ui/back-arrow.svg",
                      alt: "Back Arrow",
                      width: "9",
                      height: "14",
                    },
                  }),
                  _vm._v(" "),
                  _c("p", [_vm._v("Back")]),
                ]
              )
            : _vm._e(),
          _vm._v(" "),
          _c("div", { staticClass: "c-page-head__account-links" }, [
            _c(
              "a",
              {
                staticClass: "c-page__head__search",
                attrs: { href: "/search", "data-tour-desktop": "search" },
              },
              [
                _c(
                  "svg",
                  {
                    attrs: {
                      xmlns: "http://www.w3.org/2000/svg",
                      "xmlns:xlink": "http://www.w3.org/1999/xlink",
                      width: "18",
                      height: "18",
                      viewBox: "0 0 18 18",
                    },
                  },
                  [
                    _c("defs", [
                      _c("path", {
                        attrs: {
                          id: "icon-search-a",
                          d: "M13.6832048,12.7825544 L18.8140029,17.9133355 C19.0621641,18.1627673 19.0621641,18.5645055 18.8130114,18.8149236 C18.6920016,18.9346982 18.5305884,19 18.3636965,19 C18.1961705,19 18.0343977,18.9342171 17.9133902,18.8132099 L12.7826526,13.6824893 C11.4984497,14.7599348 9.88590202,15.3636364 8.18184472,15.3636364 C4.22175179,15.3636364 1,12.1418952 1,8.18181818 C1,4.22174116 4.22175179,1 8.18184472,1 C12.1419377,1 15.3636894,4.22174116 15.3636894,8.18181818 C15.3636894,9.88562244 14.7601512,11.498168 13.6832048,12.7825544 Z M8.18184472,14.0909091 C11.4399574,14.0909091 14.0909523,11.439923 14.0909523,8.18181818 C14.0909523,4.92371339 11.4399574,2.27272727 8.18184472,2.27272727 C4.92373202,2.27272727 2.27273715,4.92371339 2.27273715,8.18181818 C2.27273715,11.439923 4.92373202,14.0909091 8.18184472,14.0909091 Z",
                        },
                      }),
                    ]),
                    _vm._v(" "),
                    _c(
                      "g",
                      {
                        attrs: {
                          fill: "none",
                          "fill-rule": "evenodd",
                          transform: "translate(-1 -1)",
                        },
                      },
                      [
                        _c("use", {
                          attrs: {
                            fill: "#2B2A2F",
                            "fill-rule": "nonzero",
                            "xlink:href": "#icon-search-a",
                          },
                        }),
                      ]
                    ),
                  ]
                ),
              ]
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "c-page-head__links" },
              [
                _vm.user === false
                  ? [
                      _c(
                        "div",
                        {
                          staticClass:
                            "c-page__head-out u-flex u-flex-align-center",
                        },
                        [
                          _c(
                            "a",
                            {
                              staticClass: "c-page-head__notifications",
                              attrs: { href: "#" },
                              on: {
                                click: function ($event) {
                                  $event.preventDefault()
                                  return _vm.showMemberPanel.apply(
                                    null,
                                    arguments
                                  )
                                },
                              },
                            },
                            [
                              _c(
                                "svg",
                                {
                                  attrs: {
                                    xmlns: "http://www.w3.org/2000/svg",
                                    "xmlns:xlink":
                                      "http://www.w3.org/1999/xlink",
                                    width: "14",
                                    height: "18",
                                    viewBox: "0 0 14 18",
                                  },
                                },
                                [
                                  _c("defs", [
                                    _c("path", {
                                      attrs: {
                                        id: "icon-notifications-a",
                                        d: "M10.9408147,2.07306861 C12.9850781,2.39677542 14.7745599,3.80853551 14.7745599,6.55671084 L14.7745599,10.8139684 C14.7745599,11.4111298 14.8985283,11.6743135 15.2792089,12.055282 C15.332642,12.1087555 15.5512144,12.3194872 15.6015356,12.3692459 C15.746255,12.5123475 15.8649678,12.6392255 15.9808403,12.7787207 C16.3437931,13.215668 16.6282081,13.7243741 16.8536131,14.3941619 C17.0148386,14.8732678 17.0550565,15.4471784 16.9157118,15.9187372 C16.7185543,16.585941 16.1864208,17 15.397761,17 L12.9413158,17 C12.6631767,18.1583733 11.4360169,19 10.0003031,19 C8.56448559,19 7.33737574,18.1584787 7.05927533,17 L4.60284508,17 C3.81418526,17 3.2820518,16.585941 3.08489434,15.9187372 C2.94554962,15.4471784 2.98576751,14.8732678 3.14699571,14.394154 C3.37239797,13.7243741 3.65681304,13.215668 4.01976579,12.7787207 C4.13563829,12.6392255 4.25435116,12.5123475 4.39907048,12.3692459 C4.44939173,12.3194872 4.66796414,12.1087555 4.72139719,12.055282 C5.10207783,11.6743135 5.22604621,11.4111298 5.22604621,10.8139684 L5.22604621,6.55671084 C5.22604621,3.80044373 7.02608148,2.38847338 9.07785546,2.07023751 C9.0966344,1.99696299 9.11869571,1.92041544 9.14434027,1.84291957 C9.31317173,1.332724 9.54767531,1 10.0181602,1 C10.4911231,1 10.7240243,1.33419846 10.8774056,1.83317064 C10.9026433,1.91527242 10.9236075,1.99617385 10.9408147,2.07306861 Z M11.8835661,17 L8.11700041,17 C8.39075189,17.5708973 9.11819884,18 10.0003031,18 C10.8822924,18 11.6097684,17.5708376 11.8835661,17 Z M15.397761,16 C15.7351288,16 15.8829388,15.8849874 15.9567054,15.6353526 C16.0319969,15.3805574 16.0061033,15.0110549 15.9058405,14.7131088 C15.7198295,14.1603797 15.4960398,13.7601083 15.211607,13.4176887 C15.1190978,13.3063199 15.0217051,13.2022284 14.8984144,13.080316 C14.8549652,13.0373525 14.6334587,12.8237918 14.5718349,12.7621215 C14.0143277,12.2041926 13.7745599,11.6951678 13.7745599,10.8139684 L13.7745599,6.55671084 C13.7745599,5.13986739 13.2012416,4.2003169 12.2007958,3.61303684 C11.4960748,3.19935262 10.6165576,3 10.0003031,3 C9.38404846,3 8.50453134,3.19935262 7.79981028,3.61303684 C6.79936451,4.2003169 6.22604621,5.13986739 6.22604621,6.55671084 L6.22604621,10.8139684 C6.22604621,11.6951678 5.98627839,12.2041926 5.4287712,12.7621215 C5.36714742,12.8237918 5.1456409,13.0373525 5.10219169,13.080316 C4.97890105,13.2022284 4.88150827,13.3063199 4.7889991,13.4176887 C4.50456632,13.7601083 4.28077659,14.1603797 4.09476829,14.7131009 C3.9945028,15.0110549 3.96860919,15.3805574 4.0439007,15.6353526 C4.1176673,15.8849874 4.26547729,16 4.60284508,16 L15.397761,16 Z",
                                      },
                                    }),
                                  ]),
                                  _vm._v(" "),
                                  _c(
                                    "g",
                                    {
                                      attrs: {
                                        fill: "none",
                                        "fill-rule": "evenodd",
                                        transform: "translate(-3 -1)",
                                      },
                                    },
                                    [
                                      _c("use", {
                                        attrs: {
                                          fill: "#231F20",
                                          "xlink:href": "#icon-notifications-a",
                                        },
                                      }),
                                    ]
                                  ),
                                ]
                              ),
                            ]
                          ),
                          _vm._v(" "),
                          _c(
                            "a",
                            {
                              staticClass:
                                "c-page-head__avatar js-join-convo__cta",
                              attrs: {
                                href: "#",
                                "data-cy": "avatar-login-header",
                              },
                              on: {
                                click: function ($event) {
                                  $event.preventDefault()
                                  return _vm.showMemberPanel.apply(
                                    null,
                                    arguments
                                  )
                                },
                              },
                            },
                            [
                              _c("img", {
                                attrs: {
                                  src: "/img/avatar-default.svg",
                                  alt: "Default Avatar",
                                  width: "30",
                                  height: "30",
                                },
                              }),
                            ]
                          ),
                        ]
                      ),
                    ]
                  : [
                      _c("div", { staticClass: "c-page__head-in" }, [
                        _c(
                          "a",
                          {
                            staticClass: "c-page-head__notifications",
                            attrs: {
                              href: "#",
                              "data-tour-desktop": "notifications",
                            },
                            on: {
                              click: function ($event) {
                                $event.preventDefault()
                                return _vm.toggleNotifications.apply(
                                  null,
                                  arguments
                                )
                              },
                            },
                          },
                          [
                            _c(
                              "svg",
                              {
                                attrs: {
                                  xmlns: "http://www.w3.org/2000/svg",
                                  "xmlns:xlink": "http://www.w3.org/1999/xlink",
                                  width: "14",
                                  height: "18",
                                  viewBox: "0 0 14 18",
                                },
                              },
                              [
                                _c("defs", [
                                  _c("path", {
                                    attrs: {
                                      id: "icon-notifications-a",
                                      d: "M10.9408147,2.07306861 C12.9850781,2.39677542 14.7745599,3.80853551 14.7745599,6.55671084 L14.7745599,10.8139684 C14.7745599,11.4111298 14.8985283,11.6743135 15.2792089,12.055282 C15.332642,12.1087555 15.5512144,12.3194872 15.6015356,12.3692459 C15.746255,12.5123475 15.8649678,12.6392255 15.9808403,12.7787207 C16.3437931,13.215668 16.6282081,13.7243741 16.8536131,14.3941619 C17.0148386,14.8732678 17.0550565,15.4471784 16.9157118,15.9187372 C16.7185543,16.585941 16.1864208,17 15.397761,17 L12.9413158,17 C12.6631767,18.1583733 11.4360169,19 10.0003031,19 C8.56448559,19 7.33737574,18.1584787 7.05927533,17 L4.60284508,17 C3.81418526,17 3.2820518,16.585941 3.08489434,15.9187372 C2.94554962,15.4471784 2.98576751,14.8732678 3.14699571,14.394154 C3.37239797,13.7243741 3.65681304,13.215668 4.01976579,12.7787207 C4.13563829,12.6392255 4.25435116,12.5123475 4.39907048,12.3692459 C4.44939173,12.3194872 4.66796414,12.1087555 4.72139719,12.055282 C5.10207783,11.6743135 5.22604621,11.4111298 5.22604621,10.8139684 L5.22604621,6.55671084 C5.22604621,3.80044373 7.02608148,2.38847338 9.07785546,2.07023751 C9.0966344,1.99696299 9.11869571,1.92041544 9.14434027,1.84291957 C9.31317173,1.332724 9.54767531,1 10.0181602,1 C10.4911231,1 10.7240243,1.33419846 10.8774056,1.83317064 C10.9026433,1.91527242 10.9236075,1.99617385 10.9408147,2.07306861 Z M11.8835661,17 L8.11700041,17 C8.39075189,17.5708973 9.11819884,18 10.0003031,18 C10.8822924,18 11.6097684,17.5708376 11.8835661,17 Z M15.397761,16 C15.7351288,16 15.8829388,15.8849874 15.9567054,15.6353526 C16.0319969,15.3805574 16.0061033,15.0110549 15.9058405,14.7131088 C15.7198295,14.1603797 15.4960398,13.7601083 15.211607,13.4176887 C15.1190978,13.3063199 15.0217051,13.2022284 14.8984144,13.080316 C14.8549652,13.0373525 14.6334587,12.8237918 14.5718349,12.7621215 C14.0143277,12.2041926 13.7745599,11.6951678 13.7745599,10.8139684 L13.7745599,6.55671084 C13.7745599,5.13986739 13.2012416,4.2003169 12.2007958,3.61303684 C11.4960748,3.19935262 10.6165576,3 10.0003031,3 C9.38404846,3 8.50453134,3.19935262 7.79981028,3.61303684 C6.79936451,4.2003169 6.22604621,5.13986739 6.22604621,6.55671084 L6.22604621,10.8139684 C6.22604621,11.6951678 5.98627839,12.2041926 5.4287712,12.7621215 C5.36714742,12.8237918 5.1456409,13.0373525 5.10219169,13.080316 C4.97890105,13.2022284 4.88150827,13.3063199 4.7889991,13.4176887 C4.50456632,13.7601083 4.28077659,14.1603797 4.09476829,14.7131009 C3.9945028,15.0110549 3.96860919,15.3805574 4.0439007,15.6353526 C4.1176673,15.8849874 4.26547729,16 4.60284508,16 L15.397761,16 Z",
                                    },
                                  }),
                                ]),
                                _vm._v(" "),
                                _c(
                                  "g",
                                  {
                                    attrs: {
                                      fill: "none",
                                      "fill-rule": "evenodd",
                                      transform: "translate(-3 -1)",
                                    },
                                  },
                                  [
                                    _c("use", {
                                      attrs: {
                                        fill: _vm.notificationsUnread
                                          ? "#DB2848"
                                          : "#231F20",
                                        "xlink:href": "#icon-notifications-a",
                                      },
                                    }),
                                  ]
                                ),
                              ]
                            ),
                          ]
                        ),
                        _vm._v(" "),
                        _c(
                          "a",
                          {
                            staticClass: "u-flex u-flex-align-center",
                            attrs: {
                              href: "/u/" + _vm.$root.user.username,
                              "data-tour-desktop": "profile",
                              "data-cy": "profile-link",
                            },
                          },
                          [
                            _c("div", { staticClass: "c-avatar" }, [
                              _c("img", {
                                attrs: {
                                  src: _vm.$simpleStore.cloudinaryUrl(
                                    30,
                                    30,
                                    _vm.$root.user.avatar,
                                    _vm.$root
                                  ),
                                  alt: _vm.$root.user.firstName + "'s Avatar",
                                  width: "30",
                                  height: "30",
                                },
                              }),
                            ]),
                          ]
                        ),
                      ]),
                    ],
              ],
              2
            ),
          ]),
          _vm._v(" "),
          _vm._m(2),
        ],
        2
      ),
      _vm._v(" "),
      _c(
        "div",
        {
          class: [
            "c-panel__notification-target",
            _vm.showNotifications ? "open" : "",
          ],
        },
        [
          _c(
            "div",
            { staticClass: "c-panel__head c-panel__head--notifications" },
            [
              _vm._m(3),
              _vm._v(" "),
              _c(
                "div",
                {
                  staticClass: "c-panel__close",
                  on: { click: _vm.toggleNotifications },
                },
                [
                  _c("img", {
                    attrs: {
                      src: "/img/ui/icon-close-black.svg",
                      alt: "Close Icon",
                      width: "25",
                      height: "25",
                    },
                  }),
                ]
              ),
            ]
          ),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "c-panel__content c-panel__content--notifications" },
            [_c("notifications-sidebar")],
            1
          ),
          _vm._v(" "),
          _vm._m(4),
        ]
      ),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "content" },
        [_c("router-view", { attrs: { name: "index" } })],
        1
      ),
      _vm._v(" "),
      _c("footer", { staticClass: "c-page-foot" }, [
        _c("ul", [
          _c("li", [
            _c("a", { attrs: { href: "/" } }, [
              _c(
                "svg",
                {
                  attrs: {
                    width: "27px",
                    height: "24px",
                    viewBox: "0 0 27 24",
                    xmlns: "http://www.w3.org/2000/svg",
                    "xmlns:xlink": "http://www.w3.org/1999/xlink",
                  },
                },
                [
                  _c("defs"),
                  _vm._v(" "),
                  _c(
                    "g",
                    {
                      attrs: {
                        id: "Symbols-Home-Footer",
                        stroke: "none",
                        "stroke-width": "1",
                        fill: "none",
                        "fill-rule": "evenodd",
                      },
                    },
                    [
                      _c(
                        "g",
                        {
                          attrs: {
                            id: "Symbols-Home-Footer-Transform",
                            transform: "translate(-24.000000, -28.000000)",
                            fill: "#47ABC0",
                            "fill-rule": "nonzero",
                          },
                        },
                        [
                          _c("path", {
                            attrs: {
                              d: "M37.5,28 C37.5,28 29.1489,35.12 24.48195,38.976 C24.2079,39.2213333 24,39.5786667 24,40 C24,40.7373333 24.60345,41.3333333 25.35,41.3333333 L28.05,41.3333333 L28.05,50.6666667 C28.05,51.404 28.65345,52 29.4,52 L33.45,52 C34.19655,52 34.8,51.4026667 34.8,50.6666667 L34.8,45.3333333 L40.2,45.3333333 L40.2,50.6666667 C40.2,51.4026667 40.80345,52 41.55,52 L45.6,52 C46.34655,52 46.95,51.404 46.95,50.6666667 L46.95,41.3333333 L49.65,41.3333333 C50.39655,41.3333333 51,40.7373333 51,40 C51,39.5786667 50.7921,39.2213333 50.48295,38.976 C45.8484,35.12 37.5,28 37.5,28 Z",
                              id: "Shape",
                            },
                          }),
                        ]
                      ),
                    ]
                  ),
                ]
              ),
            ]),
          ]),
          _vm._v(" "),
          _c("li", [
            _c(
              "a",
              { attrs: { href: "/search", "data-tour-mobile": "search" } },
              [
                _c(
                  "svg",
                  {
                    attrs: {
                      width: "23px",
                      height: "23px",
                      viewBox: "0 0 23 23",
                      xmlns: "http://www.w3.org/2000/svg",
                      "xmlns:xlink": "http://www.w3.org/1999/xlink",
                    },
                  },
                  [
                    _c("defs"),
                    _vm._v(" "),
                    _c(
                      "g",
                      {
                        attrs: {
                          id: "Symbols-Search-Footer",
                          stroke: "none",
                          "stroke-width": "1",
                          fill: "none",
                          "fill-rule": "evenodd",
                        },
                      },
                      [
                        _c(
                          "g",
                          {
                            attrs: {
                              id: "Symbols-Search-Footer-Transform",
                              transform: "translate(-101.000000, -30.000000)",
                              fill: "#9D9D9D",
                              "fill-rule": "nonzero",
                            },
                          },
                          [
                            _c("path", {
                              attrs: {
                                d: "M117.206317,45.0554862 L123.762337,51.6114843 C124.079432,51.9302026 124.079432,52.4435348 123.76107,52.7635135 C123.606447,52.9165588 123.400196,53 123.186946,53 C122.972884,53 122.766175,52.9159441 122.611554,52.7613238 L116.055612,46.205403 C114.414686,47.5821389 112.354208,48.3535354 110.176802,48.3535354 C105.116683,48.3535354 101,44.2368661 101,39.1767677 C101,34.1166693 105.116683,30 110.176802,30 C115.23692,30 119.353603,34.1166693 119.353603,39.1767677 C119.353603,41.3538509 118.582415,43.4143257 117.206317,45.0554862 Z M110.176802,46.7272727 C114.339946,46.7272727 117.727328,43.3399016 117.727328,39.1767677 C117.727328,35.0136338 114.339946,31.6262626 110.176802,31.6262626 C106.013658,31.6262626 102.626275,35.0136338 102.626275,39.1767677 C102.626275,43.3399016 106.013658,46.7272727 110.176802,46.7272727 Z",
                                id: "Mask",
                              },
                            }),
                          ]
                        ),
                      ]
                    ),
                  ]
                ),
              ]
            ),
          ]),
          _vm._v(" "),
          _c(
            "li",
            [
              _vm.user === false
                ? [
                    _c(
                      "a",
                      {
                        staticClass: "js-join-convo__cta",
                        attrs: { href: "#" },
                        on: {
                          click: function ($event) {
                            $event.preventDefault()
                            return _vm.showMemberPanel.apply(null, arguments)
                          },
                        },
                      },
                      [
                        _c("img", {
                          attrs: {
                            src: "/img/icons/icon-add-red.svg",
                            alt: "Add",
                            width: "45",
                            height: "45",
                          },
                        }),
                      ]
                    ),
                  ]
                : _vm.publishButton
                ? [
                    _c(
                      "a",
                      {
                        attrs: { href: "#" },
                        on: {
                          click: function ($event) {
                            $event.preventDefault()
                            return _vm.publishConfirmation.apply(
                              null,
                              arguments
                            )
                          },
                        },
                      },
                      [
                        _c("img", {
                          class:
                            _vm.enableMobilePublish === false
                              ? "u-fade-button"
                              : "",
                          attrs: {
                            src: "/img/icons/icon-publish-blue.png",
                            alt: "publish",
                            width: "45",
                            height: "45",
                          },
                        }),
                      ]
                    ),
                  ]
                : [
                    _c(
                      "a",
                      { ref: "mobileCreate", attrs: { href: "/post/create" } },
                      [
                        _c("img", {
                          attrs: {
                            src: "/img/icons/icon-add-red.svg",
                            alt: "Add",
                            width: "45",
                            height: "45",
                          },
                        }),
                      ]
                    ),
                  ],
            ],
            2
          ),
          _vm._v(" "),
          _c(
            "li",
            [
              _vm.user === false
                ? [
                    _c(
                      "a",
                      {
                        attrs: { href: "#" },
                        on: {
                          click: function ($event) {
                            $event.preventDefault()
                            return _vm.showMemberPanel.apply(null, arguments)
                          },
                        },
                      },
                      [
                        _c(
                          "svg",
                          {
                            attrs: {
                              width: "18px",
                              height: "23px",
                              viewBox: "0 0 18 23",
                              version: "1.1",
                              xmlns: "http://www.w3.org/2000/svg",
                              "xmlns:xlink": "http://www.w3.org/1999/xlink",
                            },
                          },
                          [
                            _c("defs", [
                              _c("path", {
                                attrs: {
                                  d: "M266.146597,29.3711432 C268.758711,29.7847686 271.045271,31.5886843 271.045271,35.1002416 L271.045271,40.5400707 C271.045271,41.3031103 271.203675,41.6394005 271.6901,42.1261937 C271.758376,42.1945209 272.037663,42.4637892 272.101962,42.5273698 C272.286881,42.7102218 272.43857,42.8723437 272.586629,43.0505876 C273.050402,43.6089092 273.413822,44.2589225 273.701839,45.1147624 C273.907849,45.7269533 273.959239,46.4602835 273.781187,47.0628308 C273.529264,47.9153691 272.849316,48.4444444 271.841584,48.4444444 L268.702792,48.4444444 C268.347392,49.9245881 266.779355,51 264.944832,51 C263.110176,51 261.542202,49.9247227 261.186852,48.4444444 L258.04808,48.4444444 C257.040348,48.4444444 256.3604,47.9153691 256.108476,47.0628308 C255.930425,46.4602835 255.981814,45.7269533 256.187828,45.1147523 C256.475842,44.2589225 256.839261,43.6089092 257.303034,43.0505876 C257.451093,42.8723437 257.602782,42.7102218 257.787701,42.5273698 C257.852001,42.4637892 258.131288,42.1945209 258.199563,42.1261937 C258.685988,41.6394005 258.844392,41.3031103 258.844392,40.5400707 L258.844392,35.1002416 C258.844392,31.5783448 261.144437,29.7741604 263.766149,29.3675257 C263.790144,29.2738972 263.818333,29.1760864 263.851101,29.0770639 C264.066831,28.4251473 264.366474,28 264.967649,28 C265.571991,28 265.869587,28.4270314 266.065574,29.0646069 C266.097822,29.1695148 266.12461,29.2728888 266.146597,29.3711432 Z M267.351223,48.4444444 L262.538389,48.4444444 C262.888183,49.1739244 263.817699,49.7222222 264.944832,49.7222222 C266.071818,49.7222222 267.001371,49.1738481 267.351223,48.4444444 Z M271.841584,47.1666667 C272.272665,47.1666667 272.461533,47.0197061 272.55579,46.7007284 C272.651996,46.3751567 272.61891,45.9030146 272.490796,45.5223056 C272.253115,44.8160407 271.967162,44.3045829 271.60372,43.8670467 C271.485514,43.7247421 271.361068,43.5917363 271.20353,43.4359593 C271.148011,43.3810615 270.864975,43.1081785 270.786233,43.0293774 C270.073863,42.3164684 269.767493,41.6660478 269.767493,40.5400707 L269.767493,35.1002416 C269.767493,33.2898306 269.03492,32.0892938 267.756572,31.3388804 C266.856096,30.8102839 265.732268,30.5555556 264.944832,30.5555556 C264.157395,30.5555556 263.033568,30.8102839 262.133091,31.3388804 C260.854744,32.0892938 260.12217,33.2898306 260.12217,35.1002416 L260.12217,40.5400707 C260.12217,41.6660478 259.8158,42.3164684 259.10343,43.0293774 C259.024688,43.1081785 258.741652,43.3810615 258.686134,43.4359593 C258.528596,43.5917363 258.404149,43.7247421 258.285943,43.8670467 C257.922501,44.3045829 257.636548,44.8160407 257.398871,45.5222955 C257.270754,45.9030146 257.237667,46.3751567 257.333873,46.7007284 C257.42813,47.0197061 257.616999,47.1666667 258.04808,47.1666667 L271.841584,47.1666667 Z",
                                  id: "path-1",
                                },
                              }),
                            ]),
                            _vm._v(" "),
                            _c(
                              "g",
                              {
                                attrs: {
                                  id: "Symbols-Search-Notifications",
                                  stroke: "none",
                                  "stroke-width": "1",
                                  fill: "none",
                                  "fill-rule": "evenodd",
                                },
                              },
                              [
                                _c(
                                  "g",
                                  {
                                    attrs: {
                                      id: "Symbols-Search-Notifications-Transform",
                                      transform:
                                        "translate(-256.000000, -28.000000)",
                                    },
                                  },
                                  [
                                    _c(
                                      "mask",
                                      {
                                        attrs: { id: "mask-2", fill: "white" },
                                      },
                                      [
                                        _c("use", {
                                          attrs: { "xlink:href": "#path-1" },
                                        }),
                                      ]
                                    ),
                                    _vm._v(" "),
                                    _c("use", {
                                      attrs: {
                                        id: "Mask",
                                        fill: "#9D9D9D",
                                        "xlink:href": "#path-1",
                                      },
                                    }),
                                  ]
                                ),
                              ]
                            ),
                          ]
                        ),
                      ]
                    ),
                  ]
                : [
                    _c(
                      "a",
                      {
                        attrs: {
                          href: "#",
                          "data-tour-mobile": "notifications",
                        },
                        on: {
                          click: function ($event) {
                            $event.preventDefault()
                            return _vm.toggleNotifications.apply(
                              null,
                              arguments
                            )
                          },
                        },
                      },
                      [
                        _c(
                          "svg",
                          {
                            attrs: {
                              width: "18px",
                              height: "23px",
                              viewBox: "0 0 18 23",
                              version: "1.1",
                              xmlns: "http://www.w3.org/2000/svg",
                              "xmlns:xlink": "http://www.w3.org/1999/xlink",
                            },
                          },
                          [
                            _c("defs", [
                              _c("path", {
                                attrs: {
                                  d: "M266.146597,29.3711432 C268.758711,29.7847686 271.045271,31.5886843 271.045271,35.1002416 L271.045271,40.5400707 C271.045271,41.3031103 271.203675,41.6394005 271.6901,42.1261937 C271.758376,42.1945209 272.037663,42.4637892 272.101962,42.5273698 C272.286881,42.7102218 272.43857,42.8723437 272.586629,43.0505876 C273.050402,43.6089092 273.413822,44.2589225 273.701839,45.1147624 C273.907849,45.7269533 273.959239,46.4602835 273.781187,47.0628308 C273.529264,47.9153691 272.849316,48.4444444 271.841584,48.4444444 L268.702792,48.4444444 C268.347392,49.9245881 266.779355,51 264.944832,51 C263.110176,51 261.542202,49.9247227 261.186852,48.4444444 L258.04808,48.4444444 C257.040348,48.4444444 256.3604,47.9153691 256.108476,47.0628308 C255.930425,46.4602835 255.981814,45.7269533 256.187828,45.1147523 C256.475842,44.2589225 256.839261,43.6089092 257.303034,43.0505876 C257.451093,42.8723437 257.602782,42.7102218 257.787701,42.5273698 C257.852001,42.4637892 258.131288,42.1945209 258.199563,42.1261937 C258.685988,41.6394005 258.844392,41.3031103 258.844392,40.5400707 L258.844392,35.1002416 C258.844392,31.5783448 261.144437,29.7741604 263.766149,29.3675257 C263.790144,29.2738972 263.818333,29.1760864 263.851101,29.0770639 C264.066831,28.4251473 264.366474,28 264.967649,28 C265.571991,28 265.869587,28.4270314 266.065574,29.0646069 C266.097822,29.1695148 266.12461,29.2728888 266.146597,29.3711432 Z M267.351223,48.4444444 L262.538389,48.4444444 C262.888183,49.1739244 263.817699,49.7222222 264.944832,49.7222222 C266.071818,49.7222222 267.001371,49.1738481 267.351223,48.4444444 Z M271.841584,47.1666667 C272.272665,47.1666667 272.461533,47.0197061 272.55579,46.7007284 C272.651996,46.3751567 272.61891,45.9030146 272.490796,45.5223056 C272.253115,44.8160407 271.967162,44.3045829 271.60372,43.8670467 C271.485514,43.7247421 271.361068,43.5917363 271.20353,43.4359593 C271.148011,43.3810615 270.864975,43.1081785 270.786233,43.0293774 C270.073863,42.3164684 269.767493,41.6660478 269.767493,40.5400707 L269.767493,35.1002416 C269.767493,33.2898306 269.03492,32.0892938 267.756572,31.3388804 C266.856096,30.8102839 265.732268,30.5555556 264.944832,30.5555556 C264.157395,30.5555556 263.033568,30.8102839 262.133091,31.3388804 C260.854744,32.0892938 260.12217,33.2898306 260.12217,35.1002416 L260.12217,40.5400707 C260.12217,41.6660478 259.8158,42.3164684 259.10343,43.0293774 C259.024688,43.1081785 258.741652,43.3810615 258.686134,43.4359593 C258.528596,43.5917363 258.404149,43.7247421 258.285943,43.8670467 C257.922501,44.3045829 257.636548,44.8160407 257.398871,45.5222955 C257.270754,45.9030146 257.237667,46.3751567 257.333873,46.7007284 C257.42813,47.0197061 257.616999,47.1666667 258.04808,47.1666667 L271.841584,47.1666667 Z",
                                  id: "path-1",
                                },
                              }),
                            ]),
                            _vm._v(" "),
                            _c(
                              "g",
                              {
                                attrs: {
                                  id: "Symbols-Search-Notifications",
                                  stroke: "none",
                                  "stroke-width": "1",
                                  fill: "none",
                                  "fill-rule": "evenodd",
                                },
                              },
                              [
                                _c(
                                  "g",
                                  {
                                    attrs: {
                                      id: "Symbols-Search-Notifications-Transform",
                                      transform:
                                        "translate(-256.000000, -28.000000)",
                                    },
                                  },
                                  [
                                    _c(
                                      "mask",
                                      {
                                        attrs: { id: "mask-2", fill: "white" },
                                      },
                                      [
                                        _c("use", {
                                          attrs: { "xlink:href": "#path-1" },
                                        }),
                                      ]
                                    ),
                                    _vm._v(" "),
                                    _c("use", {
                                      attrs: {
                                        id: "Mask",
                                        fill: _vm.notificationsUnread
                                          ? "#DB2848"
                                          : "#9D9D9D",
                                        "xlink:href": "#path-1",
                                      },
                                    }),
                                  ]
                                ),
                              ]
                            ),
                          ]
                        ),
                      ]
                    ),
                  ],
            ],
            2
          ),
          _vm._v(" "),
          _c(
            "li",
            [
              _vm.user === false
                ? [
                    _c(
                      "a",
                      {
                        staticClass: "js-join-convo__cta",
                        attrs: { href: "#", "data-cy": "avatar-login-footer" },
                        on: {
                          click: function ($event) {
                            $event.preventDefault()
                            return _vm.showMemberPanel.apply(null, arguments)
                          },
                        },
                      },
                      [_vm._m(5)]
                    ),
                  ]
                : [
                    _c(
                      "a",
                      {
                        attrs: {
                          href: "/u/" + _vm.$root.user.username,
                          "data-tour-mobile": "profile",
                        },
                      },
                      [
                        _c("div", { staticClass: "c-avatar" }, [
                          _c("img", {
                            attrs: {
                              src: _vm.$simpleStore.cloudinaryUrl(
                                26,
                                26,
                                _vm.$root.user.avatar,
                                _vm.$root
                              ),
                              alt: _vm.$root.user.firstName + "'s Avatar",
                              width: "26",
                              height: "26",
                            },
                          }),
                        ]),
                      ]
                    ),
                  ],
            ],
            2
          ),
        ]),
      ]),
      _vm._v(" "),
      _vm.user === false || _vm.cookiePolicy === true
        ? _c(
            "div",
            {
              class: [
                "c-join-conversation",
                _vm.showCookiesPanel ? "cookie-consent" : "",
              ],
              attrs: { "data-cy": "panel-join" },
            },
            [_c("router-view", { attrs: { name: "userPanels" } })],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _c("router-view", { attrs: { name: "invitesPanel" } }),
      _vm._v(" "),
      _c("router-view", { attrs: { name: "tour" } }),
    ],
    1
  )
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c(
      "a",
      { staticClass: "c-page-head__logo u-hidden@l", attrs: { href: "/" } },
      [
        _c("img", {
          attrs: {
            src: "/img/logo-dyadey-main.svg",
            alt: "Dyadey",
            width: "171",
            height: "33",
          },
        }),
      ]
    )
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c(
      "a",
      { staticClass: "c-page-head__logo u-hidden@l", attrs: { href: "/" } },
      [
        _c("img", {
          attrs: {
            src: "/img/logo-dyadey-main.svg",
            alt: "Dyadey",
            width: "171",
            height: "33",
          },
        }),
      ]
    )
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c(
      "a",
      {
        staticClass: "c-page-head__communities",
        attrs: { href: "/communities", "data-tour-mobile": "communities" },
      },
      [
        _c("img", {
          attrs: {
            src: "/img/icons/icon-communities-squares.svg",
            alt: "Communities",
            width: "16",
            height: "16",
          },
        }),
      ]
    )
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "c-panel__notifications" }, [
      _c("img", {
        attrs: {
          src: "/img/ui/notifications.svg",
          alt: "Notifications Icon",
          width: "14",
          height: "18",
        },
      }),
      _vm._v(" "),
      _c("p", [_vm._v("Notifications")]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c(
      "div",
      { staticClass: "c-panel__footer c-panel__footer--notifications" },
      [
        _c(
          "a",
          {
            staticClass: "c-btn c-btn--black is-outline",
            attrs: { href: "/notifications" },
          },
          [_vm._v("See All")]
        ),
      ]
    )
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "c-avatar" }, [
      _c("img", {
        attrs: {
          src: "/img/avatar-default.svg",
          alt: "Avatar",
          width: "26",
          height: "26",
        },
      }),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }